import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';

class SegmentItem extends React.Component {
  onconfirmDeleteSegment = e => {
    e.stopPropagation();
    this.props.confirmDeleteSegment(this.props.uuid);
  };
  onSelectSegment = e => {
    e.stopPropagation();
    this.props.selectSegment(this.props.uuid);
  };
  onEditPress = e => {
    e.stopPropagation();
    this.props.handleEdit(this.props.uuid, this.props.name, this.props.filters);
  };
  formatDate = date => moment(date).format('MMMM DD, YYYY');

  renderItem = () => {
    return (
      <div
        className={`tvt-audience-segment__segment-list-item ${
          this.props.bgColor ? 'alternate-bg' : ''
        } ${this.props.invalid ? 'invalid-segment' : ''}`}
        onKeyPress={this.onSelectSegment}
        onClick={this.props.invalid ? () => {} : this.onSelectSegment}
        role="button"
        tabIndex={this.props.index}
      >
        <div className="tvt-audience-segment__segment-list-column-name">
          <div
            className={`tvt-audience-segment__segment-list-column-checkbox${
              this.props.isSelected ? ' selected' : ''
            }`}
          >
            {this.props.isSelected && (
              <FontAwesomeIcon icon="check" size="1x" />
            )}
          </div>
          {this.props.name}
        </div>
        <div className="tvt-audience-segment__segment-list-column-created">
          {this.props.dateCreated
            ? this.formatDate(this.props.dateCreated)
            : ''}
        </div>
        <div className="tvt-audience-segment__segment-list-column-modified">
          {this.props.dateModified
            ? this.formatDate(this.props.dateModified)
            : ''}
        </div>
        <div className="tvt-audience-segment__segment-list-column-edit">
          <FontAwesomeIcon
            onClick={this.onEditPress}
            icon="pencil-alt"
            size="1x"
          />
        </div>
        <div className="tvt-audience-segment__segment-list-column-delete">
          <FontAwesomeIcon
            onClick={this.onconfirmDeleteSegment}
            value={this.props.uuid}
            icon="trash-alt"
            size="1x"
          />
        </div>
      </div>
    );
  };

  render() {
    return this.props.invalid ? (
      <OverlayTrigger
        key={this.props.index}
        placement="bottom"
        show={this.props.invalid}
        overlay={
          <Tooltip id={`tooltip-${this.props.uuid}`}>
            This Segment includes filters that do not apply to current page
          </Tooltip>
        }
      >
        {this.renderItem()}
      </OverlayTrigger>
    ) : (
      this.renderItem()
    );
  }
}

SegmentItem.propTypes = {
  uuid: PropTypes.string,
  name: PropTypes.string,
  index: PropTypes.number,
  filters: PropTypes.string,
  isSelected: PropTypes.bool,
  dateCreated: PropTypes.number,
  dateModified: PropTypes.number,
  confirmDeleteSegment: PropTypes.func.isRequired,
  selectSegment: PropTypes.func.isRequired,
  handleEdit: PropTypes.func.isRequired,
  invalid: PropTypes.bool
};

SegmentItem.defaultProps = {
  uuid: '',
  name: '',
  dateCreated: '',
  dateModified: '',
  filters: '',
  isSelected: false,
  invalid: false
};

export default SegmentItem;
